var _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPackagesMenuIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "delivery-box_726516",
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_28928",
    "data-name": "Group 28928",
    transform: "translate(15.313)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28927",
    "data-name": "Group 28927"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39816",
    "data-name": "Path 39816",
    d: "M294.853.437A1.806,1.806,0,0,0,293.673,0H288l1.813,5.438h10.875Z",
    transform: "translate(-288)",
    fill: "#fff"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_28930",
    "data-name": "Group 28930"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28929",
    "data-name": "Group 28929"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39817",
    "data-name": "Path 39817",
    d: "M7.014,0a1.806,1.806,0,0,0-1.18.437L0,5.438H10.875L12.688,0Z",
    fill: "#fff"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_28932",
    "data-name": "Group 28932",
    transform: "translate(0 7.25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28931",
    "data-name": "Group 28931"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39818",
    "data-name": "Path 39818",
    d: "M17.5,128v5.188l-1.75-1.729L14,133.188l-1.75-1.729-1.75,1.729V128H0v19.021a1.74,1.74,0,0,0,1.75,1.729h24.5A1.74,1.74,0,0,0,28,147.021V128ZM7,145.292H4.375a.865.865,0,1,1,0-1.729H7a.865.865,0,1,1,0,1.729Zm2.625-3.458H4.375a.865.865,0,1,1,0-1.729h5.25a.865.865,0,1,1,0,1.729Z",
    transform: "translate(0 -128)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPackagesMenuIcon);
export default __webpack_public_path__ + "static/media/packages_menu_icon.b8c22779dbafec861934ac7787222093.svg";
export { ForwardRef as ReactComponent };